/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { notificacionesControllerActualizarConfiguracionNotificaciones } from '../fn/paciente-notificaciones/notificaciones-controller-actualizar-configuracion-notificaciones';
import { NotificacionesControllerActualizarConfiguracionNotificaciones$Params } from '../fn/paciente-notificaciones/notificaciones-controller-actualizar-configuracion-notificaciones';
import { notificacionesControllerMarcarNotificacionLeida } from '../fn/paciente-notificaciones/notificaciones-controller-marcar-notificacion-leida';
import { NotificacionesControllerMarcarNotificacionLeida$Params } from '../fn/paciente-notificaciones/notificaciones-controller-marcar-notificacion-leida';
import { notificacionesControllerObtenerConfiguracionNotificaciones } from '../fn/paciente-notificaciones/notificaciones-controller-obtener-configuracion-notificaciones';
import { NotificacionesControllerObtenerConfiguracionNotificaciones$Params } from '../fn/paciente-notificaciones/notificaciones-controller-obtener-configuracion-notificaciones';
import { notificacionesControllerObtenerNotificaciones } from '../fn/paciente-notificaciones/notificaciones-controller-obtener-notificaciones';
import { NotificacionesControllerObtenerNotificaciones$Params } from '../fn/paciente-notificaciones/notificaciones-controller-obtener-notificaciones';
import { NotificacionesDto } from '../models/notificaciones-dto';
import { NotificacionesModelDto } from '../models/notificaciones-model-dto';

@Injectable({ providedIn: 'root' })
export class PacienteNotificacionesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `notificacionesControllerObtenerNotificaciones()` */
  static readonly NotificacionesControllerObtenerNotificacionesPath = '/api/notificaciones/obtener-notificaciones';

  /**
   * Obtener notificaciones.
   *
   * Obtiene las notificaciones de un programa específico.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificacionesControllerObtenerNotificaciones()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificacionesControllerObtenerNotificaciones$Response(params?: NotificacionesControllerObtenerNotificaciones$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NotificacionesModelDto>>> {
    return notificacionesControllerObtenerNotificaciones(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener notificaciones.
   *
   * Obtiene las notificaciones de un programa específico.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificacionesControllerObtenerNotificaciones$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificacionesControllerObtenerNotificaciones(params?: NotificacionesControllerObtenerNotificaciones$Params, context?: HttpContext): Observable<Array<NotificacionesModelDto>> {
    return this.notificacionesControllerObtenerNotificaciones$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<NotificacionesModelDto>>): Array<NotificacionesModelDto> => r.body)
    );
  }

  /** Path part for operation `notificacionesControllerMarcarNotificacionLeida()` */
  static readonly NotificacionesControllerMarcarNotificacionLeidaPath = '/api/notificaciones/marcar-notificacion-leida/{uuidNotificacion}';

  /**
   * Marcar notificación como leída.
   *
   * Marca una notificación específica como leída.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificacionesControllerMarcarNotificacionLeida()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificacionesControllerMarcarNotificacionLeida$Response(params: NotificacionesControllerMarcarNotificacionLeida$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return notificacionesControllerMarcarNotificacionLeida(this.http, this.rootUrl, params, context);
  }

  /**
   * Marcar notificación como leída.
   *
   * Marca una notificación específica como leída.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificacionesControllerMarcarNotificacionLeida$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificacionesControllerMarcarNotificacionLeida(params: NotificacionesControllerMarcarNotificacionLeida$Params, context?: HttpContext): Observable<void> {
    return this.notificacionesControllerMarcarNotificacionLeida$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `notificacionesControllerObtenerConfiguracionNotificaciones()` */
  static readonly NotificacionesControllerObtenerConfiguracionNotificacionesPath = '/api/notificaciones/configuracion-notificaciones';

  /**
   * Obtener configuración de notificaciones.
   *
   * Obtiene la configuración de notificaciones del usuario.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificacionesControllerObtenerConfiguracionNotificaciones()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificacionesControllerObtenerConfiguracionNotificaciones$Response(params?: NotificacionesControllerObtenerConfiguracionNotificaciones$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificacionesDto>> {
    return notificacionesControllerObtenerConfiguracionNotificaciones(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener configuración de notificaciones.
   *
   * Obtiene la configuración de notificaciones del usuario.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificacionesControllerObtenerConfiguracionNotificaciones$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificacionesControllerObtenerConfiguracionNotificaciones(params?: NotificacionesControllerObtenerConfiguracionNotificaciones$Params, context?: HttpContext): Observable<NotificacionesDto> {
    return this.notificacionesControllerObtenerConfiguracionNotificaciones$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificacionesDto>): NotificacionesDto => r.body)
    );
  }

  /** Path part for operation `notificacionesControllerActualizarConfiguracionNotificaciones()` */
  static readonly NotificacionesControllerActualizarConfiguracionNotificacionesPath = '/api/notificaciones/actualizar-configuracion-notificaciones';

  /**
   * Actualizar configuración de notificaciones.
   *
   * Actualiza la configuración de notificaciones del usuario.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificacionesControllerActualizarConfiguracionNotificaciones()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  notificacionesControllerActualizarConfiguracionNotificaciones$Response(params: NotificacionesControllerActualizarConfiguracionNotificaciones$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return notificacionesControllerActualizarConfiguracionNotificaciones(this.http, this.rootUrl, params, context);
  }

  /**
   * Actualizar configuración de notificaciones.
   *
   * Actualiza la configuración de notificaciones del usuario.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificacionesControllerActualizarConfiguracionNotificaciones$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  notificacionesControllerActualizarConfiguracionNotificaciones(params: NotificacionesControllerActualizarConfiguracionNotificaciones$Params, context?: HttpContext): Observable<void> {
    return this.notificacionesControllerActualizarConfiguracionNotificaciones$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
